export enum DueTime {
    Asap = 'asap',
    SixMonths = 'sixMonths',
    OneYear = 'oneYear',
    NextYear = 'nextYear',
    NoSalesIntent = 'noSalesIntent',
}
